<!-- Ends of one side of a network rule: an apps group shows how many resources it stands for right now -->
<ng-template #ruleEndpoints let-networkRule="networkRule" let-side="side">
  @if (networkRule.modeOf(side) == 'any') {
    <span class="badge badge-blue">any</span>
  } @else {
    @for (endpoint of networkRule.endpointsOf(side); track $index) {
      @let description = describeEndpoint(endpoint);
      @if (endpoint.kind == 'apps_group') {
        <app-apps-group-ref [endpoint]="endpoint" [description]="description"></app-apps-group-ref>
      } @else {
        <span [attr.class]="description.missing ? 'badge badge-danger' : 'badge badge-blue'" [title]="description.title">
          @if (endpoint.kind == 'network') { net: }
          @if (endpoint.kind == 'resource_type') { type: }
          {{ description.label }}
        </span>
      }
    } @empty {
      <span class="badge badge-danger" title="No end is listed: this side matches no flow">nothing</span>
    }
  }
</ng-template>




<div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; display: flex; flex-flow: column;">

  <clr-modal [(clrModalOpen)]="showFlowModal" [clrModalClosable]="true" [clrModalStaticBackdrop]="false" [clrModalSize]="'xl'">
        <div class="modal-body">
            <div class="clr-row">
                <div class="clr-col-12">
                    <h3>{{ selectFlowDetailsModalTitle }}</h3>
<!--                    <app-netscope-flows-datagrid-->
<!--                      [temporalParameter]="temporalParameter"-->
<!--                      [flowDetails]="selectFlowDetails"-->
<!--                      [exportCsvEnabled]="true"-->
<!--                      *ngIf="showFlowModal">-->
<!--                    </app-netscope-flows-datagrid>-->
                    <app-netscope-flows-datagrid
                      [thirdPartyRefresh]="flowsRepositoryModal?.refresh"
                      [flowsRepository]="flowsRepositoryModal"
                      [totalItemsCount]="flowsRepositoryModal?.totalItemsCount"
                      [switchFocus]="switchFocus"
                      [temporalParameter]="temporalParameter"
                      [exportCsvEnabled]="true"
                      [flowDetails]="flowsRepositoryModal.dashboardFlows"
                      *ngIf="showFlowModal">
                    </app-netscope-flows-datagrid>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="showFlowModal = false">
                Close
            </button>
        </div>
    </clr-modal>

  <clr-modal [(clrModalOpen)]="showFlowDescriptionModal" [clrModalClosable]="true" [clrModalSize]="'lg'">
    <h3 class="modal-title">Editing flow description</h3>
    <div class="modal-body">
      @if (editedFlowDescription != undefined) {
        <app-flows-descriptions-edit-component
          [flowDescription]="editedFlowDescription"
        ></app-flows-descriptions-edit-component>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="showFlowDescriptionModal = false">
        Close
      </button>
    </div>
  </clr-modal>

  <clr-modal [(clrModalOpen)]="showNetworkRuleModal" [clrModalClosable]="true" [clrModalSize]="'lg'">
    <h3 class="modal-title">Editing network rule of '{{ editedNetworkRuleOwner?.name }}'</h3>
    <div class="modal-body">
      @if (editedNetworkRule != undefined) {
        <app-flows-descriptions-network-rule-edit
          [networkRule]="editedNetworkRule"
          [appsGroupsResolver]="appsGroupsResolver"
          [resourceName]="resourceName"
        ></app-flows-descriptions-network-rule-edit>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="showNetworkRuleModal = false">
        Close
      </button>
    </div>
  </clr-modal>



  <clr-alert [clrAlertType]="'danger'" [clrAlertAppLevel]="true" *ngIf="failureMode && !isLoading">
    <clr-alert-item>
      <span class="alert-text">Cannot load data from DC Netscope API. Please check the diagnostic page.</span>
      <div class="alert-actions">
        <a routerLink="/diagnostic" routerLinkActive="active">
          <button class="btn alert-action">
            <cds-icon shape="checkbox-list"></cds-icon>
            Diagnostic
          </button>
        </a>
      </div>
    </clr-alert-item>
  </clr-alert>


  @if (!hideNotReady) {
    <div class="clr-row" style="padding: 15px;">
      <div class="clr-col-3" style="position: relative; padding: 10px;">
        <div class="card" style="margin-top: 0px">
          <div class="card-header">
            Coverage
          </div>
          <div class="card-block">
            <div class="card-text">
              <div echarts id="coverage-gauge-chart" [options]="coverageGaugeOptions" class="demo-chart"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="clr-col-3" style="position: relative; padding: 10px;">
        <div class="card" style="margin-top: 0px">
          <div class="card-header">
            Classification
          </div>
          <div class="card-block">
            <div class="card-text">
              <div echarts id="classification-chart" [options]="classificationChartOptions" (chartClick)="clickClassificationChartEventHandler($event)"  class="demo-chart"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="clr-col-6" style="position: relative; padding: 10px;">
        <div class="card" style="margin-top: 0px">
          <div class="card-header">
            Described/Undescribed flows by resource types
          </div>
          <div class="card-block">
            <div class="card-text">
              <div echarts id="flows-descriptions-sankey-chart" [options]="sankeyOptions" (chartClick)="clickSankeyEventHandler($event)" class="demo-chart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="clr-row" style="padding: 15px;">
    <div class="clr-col" style="position: relative; padding: 5px;">
      <clr-tabs>
        <clr-tab>
          <button clrTabLink>Flows Descriptions</button>
          <clr-tab-content *clrIfActive>
            <div class="clr-row" style="margin: 0px; margin-top: 10px;">
              <div class="clr-col-8">
            <span>

                <button (click)="addFlowDescription()" class="btn btn-success btn-sm" style="z-index: 1;"
                        *ngIf="!isPushingFlowsDescriptions">
                  Add flow description
                </button>

                <input #yamlFileInput type="file" accept=".yaml,.yml" style="display: none;"
                       (change)="importFlowsDescriptionsFromYaml($event)"/>
                <button (click)="yamlFileInput.click()" class="btn btn-primary btn-sm btn-icon"
                        style="margin-left: 15px;">
                    Import from YAML
                </button>

                <button (click)="exportFlowsDescriptionsAsYaml()" class="btn btn-primary btn-sm btn-icon">
                    Save as YAML
                </button>

                <span *ngIf="isLoading" style="margin: 0px;">
                    <clr-spinner [clrSmall]="true">Loading ...</clr-spinner>
                </span>
            </span>
              </div>
              <div class="clr-col-4">
            <span *ngIf="!isLoading" style="float: right;">
                <button (click)="reloadData()" class="btn btn-primary btn-sm" style="z-index: 1; float: right;">
                    <cds-icon shape="undo"></cds-icon>
                    reset
                </button>
                <button class="btn btn-outline btn-sm" style="z-index: 1; float: right;"
                        *ngIf="isPushingFlowsDescriptions">
                    <clr-spinner clrInline>
                    </clr-spinner>
                    pushing
                </button>
                <button (click)="pushData()" class="btn btn-success btn-sm" style="z-index: 1; float: right;"
                        *ngIf="!isPushingFlowsDescriptions">
                    <cds-icon shape="floppy"></cds-icon>
                    save
                </button>
            </span>
              </div>
            </div>
            <clr-alert *ngIf="yamlImportError" [clrAlertType]="'danger'" [clrAlertSizeSmall]="true"
                       (clrAlertClosedChange)="yamlImportError = undefined" style="margin-top: 10px;">
              <clr-alert-item>
                <span class="alert-text">{{ yamlImportError }}</span>
              </clr-alert-item>
            </clr-alert>

            <div class="clr-row" style="margin: 0px;">
              <div class="clr-col">
                <clr-datagrid>
                  <clr-dg-column>Name</clr-dg-column>
                  <clr-dg-column>Comment</clr-dg-column>
                  <clr-dg-column>Authorized</clr-dg-column>
                  <clr-dg-column>Risk</clr-dg-column>
                  <clr-dg-column>Data classification</clr-dg-column>
                  <clr-dg-column>Network rules</clr-dg-column>
                  <clr-dg-column>Coverage</clr-dg-column>
                  <clr-dg-column>Actions</clr-dg-column>

                  <clr-dg-row
                    *clrDgItems="let flowDescription of flowsDescriptionsData; let i = index"
                    [clrDgItem]="flowDescription"
                  >
                    <clr-dg-cell>{{ flowDescription.name }}</clr-dg-cell>
                    <clr-dg-cell>{{ flowDescription.comment }}</clr-dg-cell>
                    <clr-dg-cell>
                      @if (flowDescription.authorized) {
                        yes
                      } @else {
                        no
                      }
                    </clr-dg-cell>
                    <clr-dg-cell>
                      <span [attr.class]="flowDescription.riskBadgeClass()">{{ flowDescription.risk }}</span>
                    </clr-dg-cell>
                    <clr-dg-cell>
                      @for (dataClassification of flowDescription.dataClassifications; track dataClassification) {
                        <span class="label label-blue">{{ dataClassification }}</span>
                      }

                      @if (flowDescription.dataClassifications.length == 0) {
                        none
                      }
                    </clr-dg-cell>
                    <clr-dg-cell>
                      @if (flowDescription.networkRules.length == 1) {
                        1 network rule
                      } @else {
                        {{ flowDescription.networkRules.length }} network rules
                      }
                    </clr-dg-cell>
                    <clr-dg-cell>
                      @let coverage = descriptionsCoverage.get(flowDescription);
                      @if (coverage != undefined) {
                        {{ coverage.flows_count }} flows ({{ formatBytes(coverage.exchanged_bytes) }})
                      } @else {
                        <span class="badge badge-warning" title="No flow is matched by this description">no flow</span>
                      }
                    </clr-dg-cell>
                    <clr-dg-cell>
                      <button (click)="editFlowDescription(flowDescription)" class="btn btn-primary btn-sm">
                        edit
                      </button>
                      <button (click)="deleteFlowDescription(flowDescription)" class="btn btn-danger btn-sm">
                        delete
                      </button>
                    </clr-dg-cell>

                    <clr-dg-row-detail *clrIfExpanded>
                      <div style="padding: 10px;">
                        <button (click)="addNetworkRule(flowDescription)" class="btn btn-success btn-sm">
                          Add network rule
                        </button>

                        @if (flowDescription.networkRules.length == 0) {
                          <p>This description has no network rule yet, so it does not cover any flow.</p>
                        } @else {
                          <table class="table table-compact">
                            <thead>
                              <tr>
                                <th class="left">Source</th>
                                <th class="left">Destination</th>
                                <th class="left">Protocol</th>
                                <th class="left">Port</th>
                                <th class="left">Direction</th>
                                <th class="left">Two ways</th>
                                <th class="left">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (networkRule of flowDescription.networkRules; track networkRule) {
                                <tr>
                                  <td class="left">
                                    <ng-container *ngTemplateOutlet="ruleEndpoints; context: {networkRule: networkRule, side: 'source'}"></ng-container>
                                  </td>
                                  <td class="left">
                                    <ng-container *ngTemplateOutlet="ruleEndpoints; context: {networkRule: networkRule, side: 'destination'}"></ng-container>
                                  </td>
                                  <td class="left">{{ networkRule.protocolLabel() }}</td>
                                  <td class="left">{{ networkRule.portLabel() }}</td>
                                  <td class="left">{{ networkRule.directionLabel() }}</td>
                                  <td class="left">
                                    @if (networkRule.twoWays) {
                                      yes
                                    } @else {
                                      no
                                    }
                                  </td>
                                  <td class="left">
                                    <button (click)="editNetworkRule(flowDescription, networkRule)"
                                            class="btn btn-primary btn-sm">
                                      edit
                                    </button>
                                    <button (click)="deleteNetworkRule(flowDescription, networkRule)"
                                            class="btn btn-danger btn-sm">
                                      delete
                                    </button>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        }
                      </div>
                    </clr-dg-row-detail>
                  </clr-dg-row>

                  <clr-dg-footer>{{ flowsDescriptionsData.length }} flows descriptions</clr-dg-footer>
                </clr-datagrid>
              </div>
            </div>
          </clr-tab-content>
        </clr-tab>


        @if (!hideNotReady) {
          <clr-tab>
            <button clrTabLink>Described flows ({{ describedFlowsLabel }})</button>
            <clr-tab-content *clrIfActive>
              <app-netscope-flows-datagrid
                [thirdPartyRefresh]="describedFlowsRepository?.refresh"
                [flowsRepository]="describedFlowsRepository"
                [totalItemsCount]="describedFlowsRepository?.totalItemsCount"
                [flowDetails]="describedFlowsRepository.dashboardFlows"
                [temporalParameter]="temporalParameter"
                [updateEmitter]="shouldUpdateFilters"

                [showCountry]="true"
                [showASN]="true"

                [exportCsvEnabled]="true"
              >
              </app-netscope-flows-datagrid>
            </clr-tab-content>
          </clr-tab>
          <clr-tab>
            <button clrTabLink>Undescribed flows ({{ undescribedFlowsLabel }})</button>
            <clr-tab-content *clrIfActive>
              <app-netscope-flows-datagrid
                [thirdPartyRefresh]="undescribedFlowsRepository?.refresh"
                [flowsRepository]="undescribedFlowsRepository"
                [totalItemsCount]="undescribedFlowsRepository?.totalItemsCount"
                [flowDetails]="undescribedFlowsRepository.dashboardFlows"
                [temporalParameter]="temporalParameter"
                [updateEmitter]="shouldUpdateFilters"

                [showCountry]="true"
                [showASN]="true"

                [exportCsvEnabled]="true"
              >
              </app-netscope-flows-datagrid>
            </clr-tab-content>
          </clr-tab>
        }

      </clr-tabs>
    </div>

  </div>
</div>

